import { Job } from '@quizdb/common';

/** `text` cut to `max` characters, with an ellipsis when it was cut (QZ-D47). */
export const truncate = (text: string, max: number): string =>
  text.length <= max ? text : `${text.slice(0, max)}…`;

/**
 * A job's displayed title (PDG-D10): its plan's title once set, else its request, else its
 * study material's file name for an untitled PDF job, cut to `max` characters.
 */
export const jobDisplayTitle = (job: Job, max: number): string =>
  truncate(job.title ?? job.request ?? job.studyMaterial?.name ?? '', max);

/** The icon a job is shown with: a file for a PDF job, a message bubble for a prompt (PDG-D10). */
export const jobIcon = (job: Job): 'file-pdf' | 'message' =>
  job.method === 'pdf' ? 'file-pdf' : 'message';

/** The chunks' planned task counts, summed (QZ-D73). */
export const plannedCount = (job: Job): number =>
  job.chunks.reduce((total, chunk) => total + chunk.taskCount, 0);
